import { render } from "./MainPaging.vue?vue&type=template&id=4fcf98e3&scoped=true"
import script from "./MainPaging.vue?vue&type=script&lang=js"
export * from "./MainPaging.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=4fcf98e3&scoped=true&lang=css"
import "@/assets/css/user/pages/main.css?vue&type=style&index=1&id=4fcf98e3&scoped=true&lang=css"
import "@/assets/css/user/pages/lst-allergy.css?vue&type=style&index=2&id=4fcf98e3&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=3&id=4fcf98e3&scoped=true&lang=css"
import "@/assets/css/user/dark/main-dark.css?vue&type=style&index=4&id=4fcf98e3&scoped=true&lang=css"
import "@/assets/css/user/dark/lst-allergy-dark.css?vue&type=style&index=5&id=4fcf98e3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcf98e3"]])

export default __exports__